// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-container+div{background:#fff;border-top-left-radius:40px;border-top-right-radius:40px;margin-top:440px;min-height:100vh;position:relative}@media screen and (max-width:1264px){.title-container+div{border-top-left-radius:30px;border-top-right-radius:30px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
